import React, { useState } from "react";
import classes from "./AdminTable.module.css";
import {
  tableImg,
  tableImg2,
  messageIconBlack,
  FilterIconBlack,
  SortingIconIconBlack,
} from "../../constant/imagePath";
import { Container, Row, Col } from "react-bootstrap";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { RiArrowUpDownLine } from "react-icons/ri";
import { Button } from "../Button/Button";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import ModalSkeleton from "../../components/ModalSkeleton/ModalSkeleton";
// import BanExplanationModal from "../../components/Modals/BanExplanationModal/BanExplanationModal";
// import MessageDetailsModal from "../../components/Modals/MessageDetailsModal/MessageDetailsModal";
import UserDetailModal from "../../components/Modals/Admin/UserDetailModal/UserDetailModal";
import UnBanModal from "../../components/Modals/Admin/UnBanModal/UnBanModal";
import { AiFillCalendar } from "react-icons/ai";
import { IoTime } from "react-icons/io5";
import { MdPlace } from "react-icons/md";
import BanExplanationModal from "../../components/Modals/Admin/BanExplanationModal/BanExplanationModal";
import MessageDetailsModal from "../../components/Modals/Admin/MessageDetailsModal/MessageDetailsModal";
import { ReactSVG } from "react-svg";

export const AdminTable = ({
  data,
  renderDataWithElement,
  headings,
  name,
  onClick1,
  onClick2
}) => {
  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
      placement="bottom-end"
      {...props}
      classes={{ popper: className }}
    />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#FFFFFF",
      color: "#000",
      maxWidth: 350,
      height: 80,
      fontSize: theme.typography.pxToRem(16),
      border: "1px solid #dadde9",
      padding: 20,
      borderRadius: 15,
    },
  }));

  //   const lessonDetailsData={
  //     {
  //       icon: AiFillCalendar,
  //       description: "Mon Aug 16 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
  //     },
  //     {
  //       icon: IoTime,
  //       time: "12:30PM- 2:30PM",
  //     },
  //     {
  //       icon: MdPlace,
  //       time: "DeWitt Clinton Park, W 54th St, New York, NY",
  //     },
  // }

  return (
    <TableContainer className={classes.tableContainer}>
      <Table
        sx={{ minWidth: 650 }}
        aria-label="simple table"
        className={classes.tableMain}
        stickyHeader
      >
        <TableHead
          className={classes.tableHeads}

        >
          <TableRow >
            {headings?.map((item) => {
              return (
                <TableCell className={classes.tableHeadCell} style={{ background: Colors.neutralShadesOfWhiteSmoke }}>
                  <div className={classes.arrow}>
                    <h6
                      style={{
                        ...Fonts.h8,
                        fontSize: '14px',
                        lineHeight: '16px',
                        color: Colors.neutralShadesOfNero,
                      }}
                    >
                      {" "}
                      {item?.title}
                    </h6>
                    {item?.filter && (
                      // <CgArrowsExchangeAltV
                      //   size={20}
                      //   className={classes.filterIcon}
                      //   onClick={item?.onClick}
                      // />
                      <ReactSVG
                        beforeInjection={(svg) => svg.classList.add(classes.filterIcon)}
                        src={SortingIconIconBlack}
                        onClick={item?.onClick}
                      />
                    )}
                  </div>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {renderDataWithElement && renderDataWithElement}
          {data?.map((item) => {
            return (
              <>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <div className={classes.tableImg}>
                      {name === "user" && (
                        <div
                          className={classes.innerImgCont}
                        >
                          <img src={item?.image} alt="tableImg" />
                        </div>
                      )}
                      {name === "complaint" && (
                        <>
                          {item?.role === "student" && (
                            <div
                              className={classes.innerImgCont}
                            >
                              <img src={item?.image} alt="tableImg" />
                            </div>
                          )}
                          {item?.role === "coach" && (
                            <div
                              className={classes.innerImgCont}
                            >
                              <img src={item?.image} alt="tableImg" />
                            </div>
                          )}
                        </>
                      )}
                      <h6
                        style={{
                          ...Fonts.h6,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {" "}
                        {item?.name}
                      </h6>
                    </div>
                  </TableCell>

                  <TableCell>
                    <p
                      style={{
                        ...Fonts.b1Mobile,
                        color: Colors.neutralShadesOfNero,
                        textTransform: "capitalize",
                      }}
                    >
                      {item?.role}
                    </p>
                  </TableCell>
                  <TableCell>
                    <p
                      style={{
                        ...Fonts.b1Mobile,
                        color:
                          item?.cancel == 3
                            ? Colors.additionalShadesOfKellyGreen1
                            : item?.cancel !== 3 && Colors.neutralShadesOfNero,
                      }}
                    >
                      {item?.cancel}
                    </p>
                  </TableCell>
                  <TableCell>
                    <p
                      style={{
                        ...Fonts.b1Mobile,
                        color:
                          item?.lastCancel == "Unspecified"
                            ? Colors.deActiveColor
                            : item?.lastCancel !== "" &&
                            Colors.neutralShadesOfNero,
                      }}
                    >
                      {item?.lastCancel}
                    </p>
                  </TableCell>
                  <TableCell>
                    <p
                      style={{
                        ...Fonts.b1Mobile,
                        color: Colors.neutralShadesOfNero,
                      }}
                    >
                      {item?.rating?.toFixed(1)}
                    </p>
                  </TableCell>
                  <TableCell>
                    <div className={classes.chatAndBanndWrapper}>
                      <div className={classes.banned}>
                        <p
                          style={{ color: Colors.neutralShadesOfNero }}
                          className={
                            item?.status == "Active"
                              ? classes.tableCells
                              : classes.tableCellsGreen
                          }
                        >
                          {item?.status}
                        </p>
                      </div>

                      {item?.status == "Active" ? (
                        <Button
                          icon={messageIconBlack}
                          size="Small"
                        />
                      ) : (
                        <Button
                          icon={messageIconBlack}
                          size="Small"
                        />
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              </>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
